export default __webpack_public_path__ + "static/media/rotated_chest_up.34b05e78.svg";